import { render, staticRenderFns } from "./SArticleSearch.vue?vue&type=template&id=051fb459"
import script from "./SArticleSearch.vue?vue&type=script&lang=js"
export * from "./SArticleSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports